// extracted by mini-css-extract-plugin
export default {"cls1":"KgWW7tdyGA8nkIFKTA0R","cls2":"JBZh6w1_kT8AQvCTWeAw KgWW7tdyGA8nkIFKTA0R"};